export * from './index';

/** AUGMENTABLE_TYPES_START */
export { Title, UserSignUp } from './model/user-profile.model';
/** AUGMENTABLE_TYPES_END */
